<template lang="html">
  <v-dialog
    v-model="dialog"
    max-width="800"
    persistent
    eager=true
    transition="dialog-transition">
    <v-card
        color="primary"
        dark
        v-if="loading"
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    <v-card v-if="!loading">
      <v-toolbar flat color="primary">
        <v-card-title primary-title dark>
          <span class="headline white--text">{{ heading }} {{jobId}}</span>
        </v-card-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="$emit('update:dialog', false), $emit('update:editJobId', null)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-xl>
          <v-layout row wrap>
            <v-flex>
              <v-text-field
                name="name"
                label="Name*"
                id="name"
                required
                v-model.lazy="jobName"
                @blur="changeJobFields"
              ></v-text-field>
            <span class="red--text">* Required Fields </span>
            </v-flex>
            <v-flex md12>
              Invoices* <br/>
              (accepted file formats: *.jpg, *.jpeg, *.png )
              <v-list
                light
                dense
                expand>
                <v-list-tile
                  active-class="primary--text"
                  color="grey darken-3"
                  class="grey lighten-2"
                  ripple="ripple"
                  v-for="invoice in invoices"  :key="invoice.id">
                  Invoice - {{ invoice.id }}
                </v-list-tile>
              </v-list>
              <vue-dropzone
                ref="invoices"
                id="invoices"
                :options="invoiceOptions"
                v-on:vdropzone-file-added="changeJobFields()"
                v-on:vdropzone-success="uploadInvoiceSuccess"/>
            </v-flex>
            <v-flex md6>
              Before Photos* <br/>
              (accepted file formats: *.jpg, *.jpeg, *.png )
              <vue-dropzone
                ref="beforePhotos"
                id="beforePhotos"
                :options="beforeOptions"
                v-on:vdropzone-file-added="changeJobFields()"
                v-on:vdropzone-success="uploadBeforePhotoSuccess"/>
              <v-list
                light
                dense
                expand>
                <v-list-tile
                  active-class="primary--text"
                  color="grey darken-3"
                  class="grey lighten-2"
                  ripple="ripple"
                  v-for="photo in beforePhotos"  :key="photo.id">
                  photo - {{ photo.id }}
                </v-list-tile>
              </v-list>
            </v-flex>
            <v-flex md6>
              After Photos* <br/>
              (accepted file formats: *.jpg, *.jpeg, *.png )
              <vue-dropzone
                ref="afterPhotos"
                id="afterPhotos"
                :options="afterOptions"
                v-on:vdropzone-file-added="changeJobFields()"
                v-on:vdropzone-success="uploadAfterPhotoSuccess"/>
              <v-list
                light
                dense
                expand>
                <v-list-tile
                  active-class="primary--text"
                  color="grey darken-3"
                  class="grey lighten-2"
                  ripple="ripple"
                  v-for="photo in afterPhotos" :key="photo.id">
                  photo - {{ photo.id }}
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" dark @click="deleteJob(), $emit('update:dialog', false)">Remove Job</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="secondary" right :disabled="jobSave" @click="updateJob(), $emit('update:dialog', false)">Save</v-btn>
        <v-btn color="primary" right :disabled="saveable" @click="submitJob('Pending'), $emit('update:editJobId', null)">Submit Job</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

let currentDateTime = new Date()
export default {
  props: ['editJobId', 'edit', 'dialog'],
  data () {
    return {
      jobId: '',
      jobName: 'Draft - ' + currentDateTime.toLocaleDateString('en-US'),
      jobSave: false,
      loading: false,
      invoices: [],
      beforePhotos: [],
      afterPhotos: [],
      invoiceOptions: {
        url: process.env.API_URL,
        headers: {'Authorization': 'Bearer ' + this.$auth.accessToken},
        paramName: 'invoice_file',
        autoProcessQueue: false,
        params: {
          job_id: this.jobId
        }
      },
      beforeOptions: {
        url: process.env.API_URL,
        headers: {'Authorization': 'Bearer ' + this.$auth.accessToken},
        paramName: 'photo_file',
        autoProcessQueue: false,
        params: {
          installation_status: 'BEFORE',
          job_id: this.jobId
        }
      },
      afterOptions: {
        url: process.env.API_URL,
        headers: {'Authorization': 'Bearer ' + this.$auth.accessToken},
        paramName: 'photo_file',
        autoProcessQueue: false,
        params: {
          installation_status: 'AFTER',
          job_id: this.jobId
        }
      }
    }
  },
  computed: {
    heading () {
      if (this.edit) {
        return 'Edit Job'
      } else {
        return 'New Job'
      }
    },
    saveable () {
      if (this.jobName && this.invoices.length > 0 && this.beforePhotos.length > 0 && this.afterPhotos.length > 0) {
        return false
      } else {
        return true
      }
    },
    jId () {
      return this.editJobId || this.jobId
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  methods: {
    changeJobFields () {
      if (this.jobId === '') {
        this.newJob()
      } else {
        this.updateJob()
      }
    },
    uploadInvoiceSuccess (file) {
      var response = JSON.parse(file.xhr.response)
      this.invoices.push(response)
    },
    uploadBeforePhotoSuccess (file) {
      var response = JSON.parse(file.xhr.response)
      this.beforePhotos.push(response)
    },
    uploadAfterPhotoSuccess (file) {
      var response = JSON.parse(file.xhr.response)
      this.afterPhotos.push(response)
    },
    newJob () {
      this.jobSave = true
      this.$http({
        method: 'post',
        url: 'remodeler/jobs',
        data: {
          name: this.jobName,
          approval_status: 'Draft'
        }
      }).then((response) => {
        console.log(response)
        this.jobId = response.data.job_id
        this.$refs.invoices.setOption('url',
          process.env.API_URL + '/api/v1/remodeler/job-invoice-upload')
        this.$refs.invoices.setOption('params',
          {job_id: this.jobId})
        this.$refs.beforePhotos.setOption('url',
          process.env.API_URL + '/api/v1/remodeler/job-photo-upload')
        this.$refs.beforePhotos.setOption('params', {
          job_id: this.jobId,
          installation_status: 'BEFORE'
        })
        this.$refs.afterPhotos.setOption('url',
          process.env.API_URL + '/api/v1/remodeler/job-photo-upload')
        this.$refs.afterPhotos.setOption('params', {
          job_id: this.jobId,
          installation_status: 'AFTER'
        })
        this.$refs.invoices.processQueue()
        this.$refs.beforePhotos.processQueue()
        this.$refs.afterPhotos.processQueue()
        this.jobSave = false
      }).catch((err) => {
        console.log(err)
        this.jobSave = false
      })
    },
    updateJob () {
      this.jobSave = true
      this.$http({
        method: 'put',
        url: 'remodeler/jobs/' + this.jId,
        data: {
          name: this.jobName,
          approval_status: 'Draft'
        }
      }).then((response) => {
        this.jobSave = false
        console.log(response)
        this.$refs.invoices.setOption('url',
          process.env.API_URL + '/api/v1/remodeler/job-invoice-upload')
        this.$refs.invoices.setOption('params',
          {job_id: this.jId})
        this.$refs.beforePhotos.setOption('url',
          process.env.API_URL + '/api/v1/remodeler/job-photo-upload')
        this.$refs.beforePhotos.setOption('params', {
          job_id: this.jId,
          installation_status: 'BEFORE'
        })
        this.$refs.afterPhotos.setOption('url',
          process.env.API_URL + '/api/v1/remodeler/job-photo-upload')
        this.$refs.afterPhotos.setOption('params', {
          job_id: this.jId,
          installation_status: 'AFTER'
        })
        this.$refs.invoices.processQueue()
        this.$refs.beforePhotos.processQueue()
        this.$refs.afterPhotos.processQueue()
      }).catch((err) => {
        console.log(err)
        this.jobSave = false
      })
    },
    submitJob () {
      this.jobSave = true
      this.$http({
        method: 'post',
        url: 'remodeler/jobs/' + this.jId + '/submission',
        data: {
          name: this.jobName,
          approval_status: 'Submitted for Approval'
        }
      }).then((response) => {
        this.jobSave = false
        console.log(response)
        this.$refs.invoices.setOption('url',
          process.env.API_URL + '/api/v1/remodeler/job-invoice-upload')
        this.$refs.invoices.setOption('params',
          {job_id: this.jId})
        this.$refs.beforePhotos.setOption('url',
          process.env.API_URL + '/api/v1/remodeler/job-photo-upload')
        this.$refs.beforePhotos.setOption('params', {
          job_id: this.jId,
          installation_status: 'BEFORE'
        })
        this.$refs.afterPhotos.setOption('url',
          process.env.API_URL + '/api/v1/remodeler/job-photo-upload')
        this.$refs.afterPhotos.setOption('params', {
          job_id: this.jId,
          installation_status: 'AFTER'
        })
        this.$refs.invoices.processQueue()
        this.$refs.beforePhotos.processQueue()
        this.$refs.afterPhotos.processQueue()
        this.$emit('update:dialog', false)
      }).catch((err) => {
        console.log(err)
        this.jobSave = false
        this.$emit('update:dialog', false)
      })
    },
    getJob () {
      if (this.editJobId) {
        this.loading = true
        this.$http({
          method: 'get',
          url: '/remodeler/jobs/' + this.jId
        }).then((response) => {
          this.jobId = response.data.id
          this.jobName = response.data.name
          this.invoices = response.data.invoices
          this.beforePhotos = response.data.before_photos
          this.afterPhotos = response.data.after_photos
          this.loading = false
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    deleteJob () {
      this.$http({
        method: 'delete',
        url: 'remodeler/jobs/' + this.jId
      }).then((response) => {
        console.log('deleted')
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  mounted () {
    this.getJob()
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Jobs/_form.vue